export const translation = {
  zenit: {
    en: {
      siteTitle: "Freebet for App",
      rulesBtnText: "Rules",
      titleLine1: 'Lucky Wednesday',
      subtitleLine1: `Want a free bet for installing the app?`,
      subtitleLine2: `We'll give you the whole\xA03!`,
      bulbTagline1: "TURN IT ON!",
      bulbTagline2: "DOWNLOAD IT!",
      bulbTagline3: "BURN IT UP!",
      btnGet: "TAKE PART",
      conditionSpan1: "download and install",
      conditionText1: `the app`,
      conditionSpan2: "Register",
      conditionText2: `or log in`,
      conditionSpan3: "Get the\n" +
        "free bet",
      conditionText3: `up to 15$*`,
      qrCode: "Qr is inside" ,
      note1: "*The action is available every Wednesday.",
      note2: "**A participant of the Promotion can receive from 1 to 3 free bets of 6$ each",
      bkString: "Bookmaker Zenit",
      rightString: "All rights reserved",
      supportText: "Support:\xA0",
      supportSpan: "8 (800) 222-22-12",
      note: "*a participant of the Promotion can get from 1 to 3 free bets for 5$ each",
      step1: 'Step 1',
      step2: 'Step 2',
      rulesHeaderText: {
        main: "Terms and conditions of the Promotion\u00A0",
        span: "Lucky Wednesday"
      },
      paragraph1: '1. The action is held every Wednesday (from 00:00 to 23:59 UTC+3) for new users of the mobile app of Zenit bookmaker until December 31, 2022. A new user is a person who has registered in the mobile application or logged in for the first time during the Promotion period.',
      paragraph2: '2. The dates of the Promotion are determined by Zenit Bookmaker and may be changed at any time for any reason and without additional notification.',
      paragraph3: 'The participant of the Promotion, during the Promotion period, must install the Zenit Bookmaker mobile application, register, if he/she has not been registered on the site of the Zenit Bookmaker before, and make the first deposit to the account in the amount from 1000 rubles. The participants of the Promotion, who already have a valid account on the site, but have not used the application before, must log in to the application for the first time and click the button PARTICIPATE. ',
      paragraph4: `4. To participate in the Promotion, a new user must:`,
      paragraph5: `5. After registering and/or installing the application and fulfillment of the conditions, a free bet of 6 USD is credited to the participant's account.  `,
      paragraph6: `6. In case of loss, a second free bet in the amount of 6 USD is credited to the participant's account. `,
      paragraph7: `7. In case of loss of a bet made using the second free bet, a third free bet in the amount of 6 USD is credited to the participant's account.`,
      paragraph8: '8. Receiving a free bet for registration in the mobile application excludes receiving other starting bonuses. Participants of the Promotion, who have previously registered on the site and received another starting bonus, can get a free bet for the first authorization in the mobile application only after using or burning off the first starting bonus.',
      paragraph9: '9. The free bet is not given to users who have completed the one-click registration without confirming their phone number or email address and other personal data.',
      paragraph10: '10. Terms of use of the free bet:',
      paragraph11: '11. Free bets are awarded within 24 hours after all conditions are met.',
      paragraph12: `12. As part of the Promotion, one player can receive no more than three free bets of 6 USD each. `,
      paragraph13: '13. Zenit Bookmaker has the right to refuse to charge a free bet to a participant of the Promotion, as well as to suspend a participant from participating in any company\'s Promotions, invalidate any actions of a participant in respect of whom Zenit Bookmaker has reasonable suspicions that he knowingly unfairly exercises the rights to participate in the Promotion or abuses them, distorts data or benefits from any forgery of data necessary to participate in the Promotion, including, but not limited to the following actions:',
      paragraph14: `14. In case of detection of any of the violations of the rules of the Promotion, Zenit Bookmaker has the right to prohibit the participant from receiving free bets, cancel the winnings received using free bets and block the account of the participant of the Promotion.`,
      paragraph15: '15. For one user (one family, one address, one PC, one mobile device, common IP address, any identical account details like e-mail address, bank account, bank card details, etc.) only one bonus for participation in the Promotion is available. Any violation of Promotion rules may result in cancellation of received bonuses, as well as taking additional measures to prevent such actions.',
      paragraph16: '16. Conversion of the free bet amount in the player\'s currency:',
      tableLeftTopText: 'Amount',
      tableCenterTopText: 'Currency',
      tableCurrencyRUB: 'RUB',
      tableCurrencyUSD: 'USD',
      tableCurrencyEUR: 'EUR',
      tableCurrencyIRR: 'IRR',
      tableCurrencyBRL: 'BRL',
      tableCurrencyUAH: 'UAH',
      tableCurrencyKZT: 'KZT',
      tableCurrencyPRB: 'PRB',
      tableCurrencyTMT: 'TMT',
      tableCurrencyMDL: 'MDL',
      noFreebetText: 'free bet shall not be credited',
      stepTextIos1: `Install the TestFlight app and then 
      follow the next step`,
      blockSubtitle: 'Installation guide for IOS',
      blockSubtitleAndroid: 'Installation guide for Android',
      step1Android: 'Download here',
      stepTextAndroid: `Direct download 
or scaning QR-code`,
      stepTextIos2: 'Аfter installing TestFlight, download the Zenit app to your device.',
      btnDownload: 'DOWNLOAD',
      btnDownloadAndroid: 'DOWNLOAD\xA0Android',
      btnDownloadIOS: "DOWNLOAD\xA0IOS",
      switch1: 'Turn it on',
      switch2: 'Rock on',
      switch3: 'Light it up',
      subParagraph41: '4.1. Make a deposit of at least 1000 rubles within 40 days after registration. The deposit can be made in one sum or in installments.',
      subParagraph42: '4.2. If there is a starter bonus for registering on the website, use it or wait until the bonus has been burned off.',
      subParagraph101: '10.1. Free bet can only be used for accumulator bets',
      subParagraph102: '10.2. Free bet can be used for accumulator bets, the odds of which are not lower than 1.4  and not higher than 7. ',
      subParagraph103: '10.3 Accumulator bet must include at least 3 (three) events.',
      subParagraph104: '10.4 The free bet can be used within 6 (six) days after accrual. If a free bet was not used within the specified period of time, it will be burned. Further free bets will not be credited. The freebet must be calculated within six (6) days of accrual.',
      subParagraph105: '10.5 The use of the free bet is possible only for the entire amount of the free bet.',
      subParagraph106: '10.6 In case of winning a bet paid with the amount of the free bet, the participant of the Promotion is paid only the amount of the winnings without taking into account the amount of the free bet. The free bet is not reused.',
      subParagraph107: '10.7 Terms and conditions of the Promotion can be changed at any time without providing a reason or additional notifications.',
      subParagraph108: '10.8 By using the free bet option, you fully agree to these Terms and conditions.',
      subParagraph131: 'a) The participant was caught in actions that entailed or may entail adverse consequences of various types and degrees both for Zenit Bookmaker and for other participants and for third parties;',
      subParagraph132: 'b) in case of revealing the fact that the participant has provided information that does not correspond to reality;',
      subParagraph133: 'c) the Participant has violated the Terms and conditions of the Promotion;',
      subParagraph134: 'd) the Participant has violated the gambling rules and/or any other rules in effect;',
      subParagraph135: 'e) the Participant\'s account has been blocked.'
    },
    ru: {
      siteTitle: "Фрибет за установку МП",
      rulesBtnText: "Правила",
      titleLine1: 'Счастливая среда',
      subtitleLine1: `Хочешь фрибет за установку приложения?\u00A0`,
      subtitleLine2: `Мы дарим целых\xA03!`,
      bulbTagline1: "врубай",
      bulbTagline2: "качай",
      bulbTagline3: "зажигай",
      bulbSum: "500 ₽",
      conditionSpan1: `Скачай и установи`,
      conditionSpan1Extra: ``,
      conditionText1: "приложение",
      conditionSpan2: `Зарегистрируйся`,
      conditionText2: `
      или авторизуйся`,
      conditionSpan3: `Получи\u00A0фрибет`,
      conditionText3: "на сумму до 1500₽*",
      specialCondition: "Всё",
      bkString: "Букмекерская контора «Зенит»",
      rightString: "Все права защищены",
      supportText: "Служба поддержки:\xA0",
      supportSpan: "8 (800) 222-22-12",
      rulesHeaderText: {
        main: "Правила участия в Акции\u00A0",
        span: "Счастливая среда"
      },
      paragraph1: '1. Акция проводится каждую среду (с 00:00 до 23:59 UTC+3) для новых пользователей мобильного приложения БК "Зенит" до 31.12.2022. Новым пользователем считается пользователь, который прошел регистрацию в мобильном приложении или впервые в нем авторизовался в период действия Акции.',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК "Зенит" и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph3: '3. Участнику Акции необходимо в период проведения Акции  установить  мобильное приложение БК "Зенит", зарегистрироваться, если он ранее не был зарегистрирован на сайте БК «Зенит», и внести первый депозит на счёт на сумму от 1000 рублей. Участники Акции, которые уже имеют действующий аккаунт на сайте, но ранее не пользовались приложением, должны впервые авторизоваться в приложении и нажать кнопку УЧАСТВОВАТЬ. ',
      paragraph4: '4. Для участия в Акции новый клиент должен:',
      paragraph5: '5. После регистрации и/или установки приложения и выполнения условий на счет участника начисляется фрибет в размере 500 рублей. ',
      paragraph6: '6. В случае проигрыша на счет участника начисляется второй фрибет в размере 500 рублей. ',
      paragraph7: '7. В случае проигрыша ставки, сделанной с использованием второго фрибета, на счет участника начисляется третий фрибет в размере 500 рублей.',
      paragraph8: '8. Получение фрибета за регистрацию в мобильном приложении исключает получение других стартовых бонусов. Участники Акции, которые ранее прошли регистрацию на сайте и получили другой стартовый бонус, могут получить фрибет за первую авторизацию в мобильном приложении только после использования или сгорания первого стартового бонуса.',
      paragraph9: '9. Фрибет не выдается пользователям, которые прошли регистрацию «в один клик» без подтверждения номера телефона, адреса электронной почты и других персональных данных. ',
      paragraph10: '10. Условия использования фрибета (бесплатной ставки):',
      paragraph11: '11.  Бесплатные ставки начисляются в течение 24 часов после выполнения всех условий. ',
      paragraph12: '12. В рамках Акции один игрок может получить не более трех фрибетов по 500 рублей каждый. ',
      paragraph13: '13. БК «Зенит»  вправе отказать участнику Акции в начислении фрибета (бесплатной ставки), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК «Зенит» возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими,  искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:',
      paragraph14: '14. В случае обнаружения любого из нарушений правил Акции БК "Зенит"  вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок и заблокировать аккаунт участника Акции.',
      paragraph15: '15. Для одного пользователя (одной семьи, одного адреса, одного компьютера, одного мобильного устройства, общего IP-адреса, любых одинаковых данных аккаунтов, как e-mail-адрес, банковский счет, данные банковских карт и т.д) доступен только один бонус за участие в Акции. Любое нарушение правил Акции может повлечь аннулирование полученных бонусов, а также принятие дополнительных мер, направленных на предотвращение подобных действий.',
      paragraph16: '16. Конвертация суммы фрибета в валюте игрока:',
      tableLeftTopText: 'Сумма',
      tableCenterTopText: 'Валюта',
      title: 'Скачать приложение БК "Зенит" | Ставки онлайн',
      subTitle: 'Приложение',
      PRO500: 'Промокод: PRO500',
      blockSubtitle: 'Гайд по установке на iOS',
      btnDownload: 'СКАЧАТЬ',
      btnDownloadAndroid: "Скачать\xA0Android",
      btnDownloadIOS: "Скачать\xA0IOS",
      stepTextIos1: `Установи приложение TestFlight,
      а затем перейди ко второму шагу`,
      stepTextIos2: 'После установки TestFlight загрузи приложение Zenit на свое устройство',
      // blockSubTitle: 'Приложение для',
      blockSubtitleAndroid: 'Гайд по установке на Android',
      step1Android: 'Качай здесь',
      stepTextAndroid: `Отсканируй QR-код или загрузи
приложение напрямую`,
      qrCode: "Qr-код внутри" ,
      note1: "*Акция активна каждую среду.  ",
      note2: "**Участник Акции может получить от 1 до 3 фрибетов по 500 рублей каждый. ",
      subParagraph41: '4.1 Пополнить счёт на сумму от 1000 рублей в течение 40 дней после регистрации. Депозит может быть внесен одной суммой или частями.',
      subParagraph42: '4.2 При наличии стартового бонуса за регистрацию на сайте, использовать его или дождаться сгорания этого бонуса.',
      subParagraph101: '10.1. Фрибет может быть использован только для ставок типа экспресс',
      subParagraph102: '10.2. Коэффициент каждого события в экспресс-ставке должен быть не ниже 1.4 и не выше 7.',
      subParagraph103: '10.3 Экспресс-ставка должна включать не менее 3 (трех) событий.',
      subParagraph104: '10.4 Фрибет может быть использован в течение 6 (шести) дней после   начисления. Если фрибет не был использован в обозначенный срок, то он сгорает. Второй и третий фрибеты не начисляются. Фрибет должен быть рассчитан в течение 6 (шести) дней после начисления.',
      subParagraph105: '10.5  Совершить бесплатную ставку можно только на всю сумму фрибета.',
      subParagraph106: '10.6 В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      subParagraph107: '10.7 Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      subParagraph108: '10.8 Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      subParagraph131: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК "Зенит" , так и для иных участников и для третьих лиц;',
      subParagraph132: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraph133: 'в) участник нарушает Правила Акции;',
      subParagraph134: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraph135: 'д) аккаунт участника Акции заблокирован.'
    },
  },
  zenbet: {
    en: {
      siteTitle: "Freebet for App",
      rulesBtnText: "Rules",
      titleLine1: 'Lucky Wednesday',
      subtitleLine1: `Want a free bet for installing the app?`,
      subtitleLine2: `We'll give you the whole\xA03!`,
      bulbTagline1: "TURN IT ON!",
      bulbTagline2: "DOWNLOAD IT!",
      bulbTagline3: "BURN IT UP!",
      btnGet: "TAKE PART",
      conditionSpan1: "download and install",
      conditionSpan1Extra: `
     the app`,
      conditionSpan1Part2: "",
      conditionText1: "",
      qrCode: "Qr is inside" ,
      note1: "*The action is available every Wednesday.",
      note2: "**A participant of the Promotion can receive from 1 to 3 free bets of 6 USD each",
      conditionSpan2: "Register",
      conditionText2Extra: "or log in",
      conditionText2: ``,
      conditionExtra3: `Get the free bet`,
      conditionSpan3: "up to the 15$*",
      conditionText3: "",
      bkString: "Bookmaker Zenit",
      rightString: "All rights reserved",
      supportText: "Support:\xA0",
      supportSpan: "8 (800) 222-22-12",
      note: "*a participant of the Promotion can get from 1 to 3 free bets for 5$ each",
      step1: 'Step 1',
      step2: 'Step 2',
      rulesHeaderText: "Terms and conditions of the Promotion",
      paragraph1: '1. The Promotion is valid for new users of the mobile app of «ZENBET» Bookmaker until 31.12.2022. A new user is a user who has registered in the mobile application or has logged in for the first time since the start of the Promotion.',
      paragraph2: '2. The dates of the Promotion are determined by «ZENBET» Bookmaker and may be changed at any time for any reason and without additional notification.',
      paragraph3: '3. The participant of the Promotion must install in the «ZENBET» Bookmaker mobile application during the Promotion period, register or log in.',
      paragraph4: `4. After registering and/or installing the application, a freebet of 5 USD is credited to the participant's account. `,
      paragraph5: `5. In case of loss, a second free bet in the amount of 5 USD is credited to the participant's account. `,
      paragraph6: `6. In case of loss of a bet made using the second free bet, a third free bet in the amount of 5 USD is credited to the participant's account.`,
      paragraph7: `7. Receiving a free bet for registration in the mobile application excludes receiving other starting bonuses.`,
      paragraph8: '8. The free bet is not given to users who have completed the one-click registration without confirming their phone number or email address.',
      paragraph9: '9. Terms of use of the free bet:',
      paragraph10: '10. Free bets are awarded daily from 00:00 to 03:00 UTC+3.',
      paragraph11: '11. As part of the Promotion, one player can receive no more than three free bets of 5 USD each.',
      paragraph12: `12. «ZENBET» Bookmaker has the right to refuse to charge a free bet to a participant of the Promotion, as well as to suspend a participant from participating in any company's Promotions, invalidate any actions of a participant in respect of whom «ZENBET» Bookmaker has reasonable suspicions that he knowingly unfairly exercises the rights to participate in the Promotion or abuses them, distorts data or benefits from any forgery of data necessary to participate in the Promotion, including, but not limited to the following actions:`,
      paragraph13: '13. In case of detection of any of the violations of the rules of the Promotion, «ZENBET» Bookmaker has the right to prohibit the participant from receiving free bets, cancel the winnings received using free bets and block the account of the participant of the Promotion.',
      paragraph14: `14. Conversion of the free bet amount in the player's currency:`,
      tableLeftTopText: 'Amount',
      tableCenterTopText: 'Currency',
      tableCurrencyRUB: 'RUB',
      tableCurrencyUSD: 'USD',
      tableCurrencyEUR: 'EUR',
      tableCurrencyIRR: 'IRR',
      tableCurrencyBRL: 'BRL',
      tableCurrencyUAH: 'UAH',
      tableCurrencyKZT: 'KZT',
      tableCurrencyPRB: 'PRB',
      tableCurrencyTMT: 'TMT',
      tableCurrencyMDL: 'MDL',
      noFreebetText: 'free bet shall not be credited',
      stepTextIos1: `Install the TestFlight app and then 
      follow the next step`,
      blockSubtitle: 'Installation guide for IOS',
      blockSubtitleAndroid: 'Installation guide for Android',
      step1Android: 'Download here',
      stepTextAndroid: `Direct download 
or scaning QR-code`,
      stepTextIos2: 'Аfter installing TestFlight, download the «ZENBET» app to your device.',
      btnDownload: 'DOWNLOAD',
      btnDownloadAndroid: 'DOWNLOAD\xA0Android',
      btnDownloadIOS: "DOWNLOAD\xA0IOS",
      switch1: 'Turn it on',
      switch2: 'Rock on',
      switch3: 'Light it up',
      correctionText: "*a participant of the Promotion can get from 1 to 3 free bets for 5$ each",
      subParagraph91: '9.1. Free bet can only be used for accumulator bets',
      subParagraph92: '9.2. Free bet can be used for accumulator bets, the odds of which are not lower than 2 and not higher than 7. ',
      subParagraph93: '9.3 Accumulator bet must include at least 2 (two) events. ',
      subParagraph94: '9.4 The free bet can be used within 4 (four) days after accrual.',
      subParagraph95: '9.5  The use of the free bet is possible only for the entire amount of the free bet.',
      subParagraph96: '9.6  In case of winning a bet paid with the amount of the free bet, the participant of the Promotion is paid only the amount of the winnings without taking into account the amount of the free bet. The free bet is not reused.',
      subParagraph97: '9.7 Terms and conditions of the Promotion can be changed at any time without providing a reason or additional notifications.',
      subParagraph98: '9.8 By using the free bet option, you fully agree to these Terms and conditions.',
      subParagraph121: 'а) The participant was caught in actions that entailed or may entail adverse consequences of various types and degrees both for «ZENBET» Bookmaker and for other participants and for third parties;',
      subParagraph122: 'b) in case of revealing the fact that the participant has provided information that does not correspond to reality;',
      subParagraph123: 'c) the Participant has violated the Terms and conditions of the Promotion;',
      subParagraph124: 'd) the Participant has violated the gambling rules and/or any other rules in effect;',
      subParagraph125: `e) the Participant's account has been blocked.`
    },
    ru: {
      siteTitle: "Фрибет за установку МП",
      rulesBtnText: "Правила",
      titleLine1: 'Счастливая среда',
      subtitleLine1: `Хочешь фрибет за установку приложения?\u00A0`,
      subtitleLine2: `Мы дарим целых\xA03!`,
      bulbTagline1: "врубай",
      bulbTagline2: "качай",
      bulbTagline3: "зажигай",
      bulbSum: "500 ₽",
      conditionSpan1: `Скачай и установи`,
      conditionSpan1Extra: ``,
      conditionText1: "приложение",
      conditionSpan2: `Зарегистрируйся`,
      conditionText2: `
      или авторизуйся`,
      conditionSpan3: `Получи\u00A0фрибет`,
      conditionText3: "на сумму до 1500₽*",
      specialCondition: "Всё",
      bkString: "Букмекерская контора «ZENBET»",
      rightString: "Все права защищены",
      supportText: "Служба поддержки:\xA0",
      supportSpan: "8 (800) 222-22-12",
      rulesHeaderText: "Правила участия в Акции",
      paragraph1: '1. Акция проводится для новых пользователей мобильного приложения БК «ZENBET» до 31.12.2022. Новым пользователем считается пользователь, который прошел регистрацию в мобильном приложении или впервые в нем авторизовался с момента старта акции.',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК «ZENBET» и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph3: '3. Участнику Акции необходимо в период проведения Акции  установить  мобильное приложение БК «ZENBET», зарегистрироваться или авторизоваться в нем. ',
      paragraph4: '4. После регистрации и/или установки приложения на счет участника начисляется фрибет в размере 500 рублей.',
      paragraph5: '5. В случае проигрыша на счет участника начисляется второй фрибет в размере 500 рублей.',
      paragraph6: '6. В случае проигрыша ставки, сделанной с использованием второго фрибета, на счет участника начисляется третий фрибет в размере 500 рублей.',
      paragraph7: '7. Получение фрибета за регистрацию в мобильном приложении исключает получение других стартовых бонусов.',
      paragraph8: '8. Фрибет не выдается пользователям, которые прошли регистрацию «в один клик» без подтверждения номера телефона или адреса электронной почты.',
      paragraph9: '9. Условия использования фрибета (бесплатной ставки):',
      paragraph10: '10. Бесплатные ставки начисляются ежедневно с 00:00 до 03:00 UTC+3.',
      paragraph11: '11. В рамках Акции один игрок может получить не более трех фрибетов по 500 рублей каждый. ',
      paragraph12: '12. БК «ZENBET»  вправе отказать участнику Акции в начислении фрибета (бесплатной ставки), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК «ZENBET» возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими,  искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:',
      paragraph13: '13. В случае обнаружения любого из нарушений правил Акции БК «ZENBET»  вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок и заблокировать аккаунт участника Акции.',
      paragraph14: '14. Конвертация суммы фрибета в валюте игрока:',
      tableLeftTopText: 'Сумма',
      tableCenterTopText: 'Валюта',
      title: 'Скачать приложение БК «ZENBET» | Ставки онлайн',
      subTitle: 'Приложение',
      blockSubtitle: 'Гайд по установке на iOS',
      // blockTextAndroid: 'Чтобы установить мобильное приложение для Android, скачай его и пройди шаги из гайда.',
      // blockTextIos: 'Чтобы установить мобильное приложение для iOS, открой этот сайт на телефоне и пройди шаги из гайда ',
      btnDownload: 'СКАЧАТЬ',
      btnDownloadAndroid: "Скачать\xA0Android",
      btnDownloadIOS: "Скачать\xA0IOS",
      // btnGuide: 'Гайд по установке',
      android: 'Android',
      ios: 'iOS',
      mobTitle: 'Скачай сейчас',
      modalClose: 'Закрыть',
      modalText: 'Отсканируйте QR-код со своего мобильного для перехода на страницу с приложением. ',
      modalTitleAndroid: 'Гайд по установке на Android',
      step1: 'Шаг 1',
      step2: 'Шаг 2',
      step3: 'Шаг 3',
      step4: 'Шаг 4',
      step5: 'Шаг 5',
      stepTextAndroid1: 'Нажми кнопку OK \n' +
        'и сохрани .apk файл. ',
      stepTextAndroid2: '\n' +
        'Открой скаченный .apk файл. ',
      stepTextAndroid3: 'Отметь пункт «Разрешить установку из этого источника». ',
      stepTextAndroid4: 'После открытия установочного файла, выбери кнопку «Настройки».',
      stepTextAndroid5: 'В появившемся окне нажми «Установить»',
      stepTextIos1: `Установи приложение TestFlight,
      а затем перейди ко второму шагу`,
      stepTextIos2: 'После установки TestFlight загрузи приложение «ZENBET» на свое устройство',
      // blockSubTitle: 'Приложение для',
      blockSubtitleAndroid: 'Гайд по установке на Android',
      step1Android: 'Качай здесь',
      stepTextAndroid: `Отсканируй QR-код или загрузи
приложение напрямую
      
      `,
      qrCode: "Qr-код внутри" ,
      note1: "*Акция активна каждую среду.  ",
      note2: "**Участник Акции может получить от 1 до 3 фрибетов по 500 рублей каждый. ",
      correctionText: "* участник Акции может получить от 1 до 3 фрибетов по 500 рублей каждый ",
      noFreebetText: 'бесплатная ставка не выдается',
      subParagraph91: '9.1. Фрибет может быть использован только для ставок типа экспресс',
      subParagraph92: '9.2. Фрибет может быть использован для экспресс-ставок, коэффициент которых не ниже 2 и не выше 7. ',
      subParagraph93: '9.3 Экспресс-ставка должна включать не менее 2 (двух) событий.',
      subParagraph94: '9.4 Фрибет может быть использован в течение 4 (четырех) дней после   начисления.',
      subParagraph95: '9.5  Совершить бесплатную ставку можно только на всю сумму фрибета.',
      subParagraph96: '9.6 В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      subParagraph97: '9.7 Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      subParagraph98: '9.8 Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      subParagraph121: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК «ZENBET» , так и для иных участников и для третьих лиц;',
      subParagraph122: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraph123: 'в) участник нарушает Правила Акции;',
      subParagraph124: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraph125: 'д) аккаунт участника Акции заблокирован.'
    },
  },
  cupis: {
    ru: {
      siteTitle: "Фрибет за установку МП",
      rulesBtnText: "Правила",
      titleLine1: 'СЧАСТЛИВАЯ СРЕДА',
      subtitleLine1: `Хочешь фрибет за установку приложения?\u00A0`,
      subtitleLine2: `Мы дарим целых\xA03!`,
      btnGet: "Участвовать",
      conditionSpan1: `Скачай и установи`,
      conditionSpan1Extra: ``,
      bulbTagline1: "врубай",
      bulbTagline2: "качай",
      bulbTagline3: "зажигай",
      bulbSum: "500 ₽",
      conditionText1: "приложение",
      conditionSpan2: `Зарегистрируйся`,
      conditionText2: `
      или авторизуйся`,
      conditionSpan3: `Получи\u00A0фрибет`,
      conditionText3: "на сумму до 1500₽*",
      specialCondition: "Всё",
      bkString: "Букмекерская контора «Зенит»"  ,
      note1: "*Акция активна каждую среду.  ",
      note2: "**Участник Акции может получить от 1 до 3 фрибетов по 500 рублей каждый. ",
      rightString: "Все права защищены",
      footnoteText: '*подробнее в правилах Акции',
      supportText: "Служба поддержки:\xA0",
      supportSpan: "8 (800) 222-55-50",
      rulesHeaderText: {
        main: "Правила участия в Акции\u00A0",
        span: "Счастливая среда"
      },
      paragraph1: '1. Акция проводится каждую среду (с 00:00 до 23:59 UTC+3)  для новых пользователей мобильного приложения БК «Зенит» до 31.12.2022.',
      paragraph2: '2. Сроки проведения Акции устанавливаются БК «Зенит» и могут быть изменены в любое время без указания причин и дополнительных уведомлений.',
      paragraph3: '3. Участнику Акции необходимо в период проведения Акции  установить  мобильное приложение БК «Зенит», зарегистрироваться или впервые авторизоваться в нем, а также иметь начальный или профессиональный статус идентификации. Участники Акции, впервые авторизовавшиеся в приложении, должны нажать кнопку УЧАСТВОВАТЬ в сторис',
      paragraph4: '4. После регистрации и/или установки приложения на счет участника начисляется фрибет в размере 500 рублей. ',
      paragraph5: '5. В случае проигрыша на счет участника начисляется второй фрибет в размере 500 рублей.',
      paragraph6: '6. В случае проигрыша ставки, сделанной с использованием второго фрибета, на счет участника начисляется третий фрибет в размере 500 рублей.',
      paragraph7: '7. Получение фрибета за регистрацию в мобильном приложении исключает получение других стартовых бонусов. Участники Акции, которые ранее прошли регистрацию на сайте и получили другой стартовый бонус, могут получить фрибет за первую авторизацию в мобильном приложении только после использования или сгорания первого стартового бонуса.',
      paragraph8: '8. Фрибет не выдается пользователям, которые не прошли регистрацию полностью и не подтвердили номер телефона.',
      paragraph9: '9. Условия использования фрибета (бесплатной ставки):',
      paragraph10: '10. Бесплатные ставки начисляются в течение 24 часов после выполнения всех условий.',
      paragraph11: '11. В рамках Акции один игрок может получить не более трех фрибетов по 500 рублей каждый. ',
      paragraph12: '12. БК «Зенит»  вправе отказать участнику Акции в начислении фрибета (бесплатной ставки), а также отстранить участника от участия в любых Акциях компании, признать недействительными любые действия участника, в отношении которого у БК «Зенит» возникли обоснованные подозрения в том, что он заведомо недобросовестно осуществляет права на участие в Акции или злоупотребляет ими,  искажает данные или извлекает выгоду из любой подделки данных, необходимых для участия в Акции, в том числе, но не ограничиваясь следующими действиями:',
      paragraph13: '13. В случае обнаружения любого из нарушений правил Акции БК «Зенит»  вправе запретить участнику получение фрибетов, аннулировать выигрыши, полученные с использованием бесплатных ставок и заблокировать аккаунт участника Акции.\n',
      tableLeftTopText: 'Сумма',
      tableCenterTopText: 'Валюта',
      tableCurrencyRUB: 'RUB',
      tableCurrencyUSD: 'USD',
      tableCurrencyEUR: 'EUR',
      tableCurrencyIRR: 'IRR',
      tableCurrencyBRL: 'BRL',
      tableCurrencyUAH: 'UAH',
      tableCurrencyKZT: 'KZT',
      tableCurrencyPRB: 'PRB',
      tableCurrencyTMT: 'TMT',
      tableCurrencyMDL: 'MDL',
      title: 'Скачать приложение БК «Зенит» | Ставки онлайн',
      subTitle: 'Приложение',
      legalbet500: 'Промокод: Legalbet500',
      rb500: 'Промокод: Rb500',
      liveresult500: 'Промокод: Liveresult500',
      eurofootball500: 'Промокод: Eurofootball500',
      sports500: 'Промокод: Sports500',
      overbetting500: 'Промокод: Overbetting500',
      blockSubtitle: 'Гайд по установке на iOS',
      blockSubtitleAndroid: 'Гайд по установке на Android',
      // blockTextAndroid: 'Чтобы установить мобильное приложение для Android, скачай его и пройди шаги из гайда.',
      // blockTextIos: 'Чтобы установить мобильное приложение для iOS, открой этот сайт на телефоне и пройди шаги из гайда ',
      btnDownload: 'СКАЧАТЬ',
      btnDownloadAndroid: "Скачать\xA0Android",
      btnDownloadIOS: "Скачать\xA0IOS",
      // btnGuide: 'Гайд по установке',
      android: 'Android',
      ios: 'iOS',
      mobTitle: 'Скачай сейчас',
      modalClose: 'Закрыть',
      qrCode: "Qr-код внутри" ,
      modalText: 'Отсканируйте QR-код со своего мобильного для перехода на страницу с приложением. ',
      step1Android: 'Качай здесь',
      step1: 'Открой App Store',
      step2: 'Шаг 2',
      step3: 'Шаг 3',
      step4: 'Шаг 4',
      step5: 'Шаг 5',
      stepTextAndroid1: 'Нажми кнопку OK \n' +
          'и сохрани .apk файл. ',
      stepTextAndroid2: '\n' +
          'Открой скаченный .apk файл. ',
      stepTextAndroid3: 'Отметь пункт «Разрешить установку из этого источника». ',
      stepTextAndroid4: 'После открытия установочного файла, выбери кнопку «Настройки».',
      stepTextAndroid5: 'В появившемся окне нажми «Установить»',
      stepTextIos1: `Загрузи приложение Zenit 
на свое устройство`,
      stepTextIos2: 'После установки TestFlight загрузи приложение Zenit на свое устройство',
      // blockSubTitle: 'Приложение для',
      stepTextAndroid: `Отсканируй QR-код или загрузи
приложение напрямую`,
      switch1: 'Врубай',
      switch2: 'Качай',
      switch3: 'Зажигай',
      correctionText: "* участник Акции может получить от 1 до 3 фрибетов по 500 рублей каждый ",
      noFreebetText: 'бесплатная ставка не выдается',
      subParagraph91: '9.1. Фрибет может быть использован только для ставок типа экспресс.',
      subParagraph92: '9.2. Коэффициент каждого события в экспресс-ставке должен быть не ниже 1.4 и не выше 7.',
      subParagraph93: '9.3 Экспресс-ставка должна включать не менее 3 (трех) событий.',
      subParagraph94: '9.4 Фрибет может быть использован в течение 6 (шести) дней после   начисления. Если фрибет не был использован в обозначенный срок, то он сгорает. Второй и третий фрибеты не начисляются. Фрибет должен быть рассчитан в течение 6 (шести) дней после начисления. ',
      subParagraph95: '9.5 Совершить бесплатную ставку можно только на всю сумму фрибета.',
      subParagraph96: '9.6 В случае выигрыша ставки, оплаченной суммой фрибета, участнику Акции выплачивается только сумма выигрыша без учета суммы фрибета. Фрибет повторно не используется.',
      subParagraph97: '9.7 Условия Акции могут быть изменены и дополнены в любое время без указания причин и дополнительных уведомлений.',
      subParagraph98: '9.8 Использование фрибета подразумевает полное согласие участника Акции с настоящими Правилами.',
      subParagraph121: 'а) участник был уличен в действиях, которые повлекли или могут повлечь за собой неблагоприятные последствия различного типа и степени как для БК «Зенит» , так и для иных участников и для третьих лиц;',
      subParagraph122: 'б) в случае выявления факта предоставления участником сведений, не соответствующих действительности;',
      subParagraph123: 'в) участник нарушает Правила Акции;',
      subParagraph124: 'г) участник Акции нарушает Правила азартной игры и/или иные установленные правила;',
      subParagraph125: 'д) аккаунт участника Акции заблокирован.'
    }
  }
}
